import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { BaseEstimateStatusService } from '@http/clients/reporting-app/base-estimate-status.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-project-status-form-editor',
    templateUrl: './report-project-status-form-editor.component.html',
    styleUrls: ['./report-project-status-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportProjectStatusFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportProjectStatusFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Project Status');
    placeholderText = input<string>('Select Project Status');

    private readonly baseEstimateStatusService = inject(BaseEstimateStatusService);

    async ngOnInit(): Promise<void> {
        const statuses = await this.baseEstimateStatusService.getAll();
        this.items.set(statuses);
    }

    override writeValue(value: number[] | null): void {
        this.selectedValue.set(value ?? undefined);
        if (!value?.length) {
            this.selectedItems.set([]);
            return;
        }
        this.selectedItems.set(this.mapValueToSelectedItems(value));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
